import { Button, Popup, Text } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import styled from 'styled-components'

type ResetModalProps = {
  isOpen: boolean
  onConfirm?: () => void
  onCancel: () => void
}

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: center;
`

const ResetModal = ({ isOpen, onConfirm, onCancel }: ResetModalProps) => {
  const { t } = useTranslation()

  return (
    <Popup isOpen={isOpen} onClose={() => {}}>
      <ContentWrapper>
        <Text variant='label-required-04' as='h3'>
          {t('reset-modal.title')}
        </Text>
        <Text variant='content-04'>{t('reset-modal.content')}</Text>
        <Button onClick={onConfirm}>{t('reset-modal.confirm')}</Button>
        <Button onClick={onCancel} variant='secondary'>
          {t('reset-modal.cancel')}
        </Button>
      </ContentWrapper>
    </Popup>
  )
}

export default ResetModal
